import {useTranslation} from 'react-i18next'

import {LinkButton} from '@sdox/ui'
import {IconLocation, IconMail, IconMobile, IconPhone} from '@sdox/icons'

import {GoogleMapsButton} from '../../Dialogs/ContactCard/GoogleMapsButton'
import {getGoogleMapsLinkByCoordinates} from './utils'

import type {DealerStampProps} from '../DealerStamp'

interface ContactInfoButtonsProps {
  coordinates: {
    lat: string
    long: string
  } | null
  mail: DealerStampProps['phone'] | null
  phone: DealerStampProps['phone'] | null
}

export const ContactInfoButtons = (props: ContactInfoButtonsProps) => {
  const {coordinates, mail, phone} = props
  const {t} = useTranslation()
  const googleMapsUrl = coordinates ? getGoogleMapsLinkByCoordinates(coordinates) : null

  return (
    <div className={'flex justify-center gap-spacing-12 sm:hidden'}>
      {mail ? (
        <LinkButton
          href={`mailto:${mail}`}
          leading={<IconMail />}
          variant={'outline'}
          size={'medium'}
          aria-label={t('common:openInMail')}
          title={t('common:openInMail')}
        />
      ) : null}
      {phone ? (
        <LinkButton
          href={`tel:${phone}`}
          leading={<IconPhone />}
          variant={'outline'}
          size={'medium'}
          aria-label={t('common:call')}
          title={t('common:call')}
        />
      ) : null}
      {googleMapsUrl ? (
        <GoogleMapsButton
          size={'medium'}
          variant={'outline'}
          href={googleMapsUrl}
          leading={<IconLocation />}
        />
      ) : null}
    </div>
  )
}
